import * as React from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidRoundedIcon from '@mui/icons-material/AndroidRounded';
import { useLanguage } from '../contexts/LanguageContext';

interface StoreButtonsProps {
  compact?: boolean;
}

export default function StoreButtons({ compact = false }: StoreButtonsProps) {
  const { translations } = useLanguage();

  const storeButtonSx = {
    width: compact ? '100%' : { xs: '100%', sm: 220 },
    minHeight: compact ? 72 : 88,
    borderRadius: compact ? 3.5 : 3,
    textTransform: 'none',
    bgcolor: 'rgba(255,255,255,0.96)',
    color: '#241B3E',
    borderColor: 'rgba(255,255,255,0.72)',
    px: compact ? 1.75 : 2,
    py: compact ? 1.25 : 1.5,
    '&:hover': {
      bgcolor: '#FFFFFF',
      borderColor: '#FFFFFF',
    },
  };

  const labelVariant = compact ? 'subtitle1' : 'h6';
  const iconSize = compact ? 26 : 30;

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <Button variant="outlined" href="#" sx={storeButtonSx}>
        <Stack spacing={compact ? 0.75 : 1.25} alignItems="center" justifyContent="center" sx={{ width: '100%' }}>
          <AppleIcon sx={{ fontSize: iconSize }} />
          <Typography variant={labelVariant} sx={{ color: 'inherit', lineHeight: 1.2, textAlign: 'center', fontWeight: 700 }}>
            {translations.pricing_section.app_store}
          </Typography>
        </Stack>
      </Button>
      <Button variant="outlined" href="#" sx={storeButtonSx}>
        <Stack spacing={compact ? 0.75 : 1.25} alignItems="center" justifyContent="center" sx={{ width: '100%' }}>
          <AndroidRoundedIcon sx={{ fontSize: iconSize }} />
          <Typography variant={labelVariant} sx={{ color: 'inherit', lineHeight: 1.2, textAlign: 'center', fontWeight: 700 }}>
            {translations.pricing_section.play_store}
          </Typography>
        </Stack>
      </Button>
    </Stack>
  );
}
